import { isBefore, startOfDay } from "date-fns"
import { z } from "zod"
import { EXPORT_SCOPE, PROGRESS_NOTE_TYPE } from "@/modules/patients/detail/record-extract/types/record-extract-types"

export const recordExtractFormSchema = z
  .object({
    scope: z.enum(EXPORT_SCOPE),
    startDate: z.date().optional(),
    endDate: z.date().optional(),
    progressNoteType: z.enum(PROGRESS_NOTE_TYPE),
    episodeOfCareIds: z.array(z.string()),
    timeWindowEnabled: z.boolean(),
  })
  .superRefine(({ scope, startDate, endDate }, ctx) => {
    if (scope === EXPORT_SCOPE.custom) {
      if (!startDate) {
        ctx.addIssue({
          code: "custom",
          path: ["startDate"],
          message: "common.fieldErrorList.requiredField",
        })
      }
      if (!endDate) {
        ctx.addIssue({
          code: "custom",
          path: ["endDate"],
          message: "common.fieldErrorList.requiredField",
        })
      }
    }
    if (startDate && endDate && isBefore(startOfDay(endDate), startOfDay(startDate))) {
      ctx.addIssue({
        code: "custom",
        path: ["startDate"],
        message: "common.fieldErrorList.invalidDateRange",
      })
      ctx.addIssue({
        code: "custom",
        path: ["endDate"],
        message: "common.fieldErrorList.invalidDateRange",
      })
    }
  })

export type RecordExtractFormValues = z.infer<typeof recordExtractFormSchema>

export const recordExtractFormDefaultValues: RecordExtractFormValues = {
  scope: EXPORT_SCOPE.full,
  startDate: undefined,
  endDate: undefined,
  progressNoteType: PROGRESS_NOTE_TYPE.all,
  episodeOfCareIds: [],
  timeWindowEnabled: false,
}
